var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24CheckmarkCircle2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    fillRule: "evenodd",
    d: "M20.997 10.974H21c.551 0 .999.446 1 .997.008 2.671-1.025 5.186-2.909 7.08-1.883 1.894-4.391 2.941-7.062 2.95H12c-2.66 0-5.164-1.033-7.051-2.91C3.055 17.208 2.008 14.701 2 12.03c-.008-2.672 1.025-5.186 2.909-7.08C6.792 3.055 9.3 2.01 11.971 2c.795.012 1.605.092 2.381.278.536.13.867.67.737 1.207-.129.536-.672.866-1.206.738-.621-.15-1.28-.213-1.906-.223-2.137.006-4.144.844-5.65 2.36C4.82 7.873 3.994 9.885 4 12.022c.006 2.137.844 4.143 2.359 5.65C7.869 19.174 9.871 20 12 20h.023c2.137-.006 4.144-.844 5.65-2.359 1.507-1.516 2.333-3.527 2.327-5.664-.001-.552.445-1.002.997-1.003zm-12.704.319c.391-.391 1.023-.391 1.414 0l2.244 2.244 6.297-7.196c.364-.413.995-.457 1.411-.093.415.363.457.995.093 1.411l-7 8c-.182.208-.442.331-.719.341H12c-.265 0-.519-.105-.707-.293l-3-3c-.39-.391-.39-1.023 0-1.414z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24CheckmarkCircle2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_24_checkmark-circle-2.81bf5b89.svg";
export { ForwardRef as ReactComponent };